import app from '@/app';
import templateUrl from './road-search.html';

/* @ngInject */
function Controller($controller, Road, $state, $http, $uibModal, Principal) {
	const $ctrl = this;
	$controller('AbstractEntitySearchController', {
		$ctrl,
		resource: Road,
		type: 'road'
	});

	const transition = $ctrl.transition;

	$ctrl.transition = params => {
		transition(params);
	}

	$ctrl.showConfirmModal = () => {
		$ctrl.isConfirming = true;
	};
	  
	$ctrl.cancelImport = () => {
		$ctrl.isConfirming = false;
	};

	$ctrl.upload = (files) => {
		$ctrl.isConfirming = false;
		if (!$ctrl.readonly && files && files.length) {
			$uibModal.open({
			  component: 'roadImportDialog',
			  size: 'md',
			  resolve: {
				road: () => $ctrl.entities,
				files: () => files
			  }
			}).result.then(() => $state.reload());
		}
	};

  	Principal.identity().then(account => {
    	$ctrl.currentAccount = account;
    })

	$ctrl.onQuerySearchRoad = query => {
		$http
			.get('/api/roads', {
				params: { page: 0, query: query.query, roadtype: query.roadtype }
			})
			.then(function(response) {
				$ctrl.entities = response.data.content;
			});
	};

	$ctrl.exportLinkRoadSegments = '/api/roads/geometry/excel';

}

const component = {
	templateUrl,
	controller: Controller,
	bindings: {
		$transition$: '<',
		allOrganizations: '<'
	}
};

app.component('roadSearch', component);
